// AGC: Admin Panel - Crop Requirements Table Component
// AGC: Editable table displaying crop climate requirements

import React from 'react'
import type { CropRequirements } from '../../../types/admin/models'

interface CropRequirementsTableProps {
  crops: CropRequirements[]
  onEdit: (crop: CropRequirements) => void
}

/**
 * AGC: CropRequirementsTable - Display and edit crop requirements
 * AGC: Shows all crops with their climate parameters in a sortable table
 */
export const CropRequirementsTable: React.FC<CropRequirementsTableProps> = ({
  crops,
  onEdit,
}) => (
  <div className="bg-white dark:bg-admin-card-dark border border-slate-200 dark:border-white/5 rounded-xl overflow-hidden shadow-card dark:shadow-none">
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="bg-slate-50 dark:bg-white/[0.02]">
            <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide">
              Cultivo
            </th>
            <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide">
              Precip. (mm)
            </th>
            <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide">
              Temp. Mín (°C)
            </th>
            <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide">
              Temp. Máx (°C)
            </th>
            <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide">
              Radiação (MJ/m²)
            </th>
            <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide">
              Rend. (t/ha)
            </th>
            <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide">
              Ciclo (dias)
            </th>
            <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide">
              Ações
            </th>
          </tr>
        </thead>
        <tbody>
          {crops.map((crop) => (
            <tr key={crop.id} className="border-b border-slate-100 dark:border-white/5 hover:bg-slate-50 dark:hover:bg-white/[0.02]">
              <td className="px-4 py-3">
                <div className="flex items-center gap-3">
                  <span
                    className="w-8 h-8 rounded-lg flex items-center justify-center text-lg"
                    style={{ backgroundColor: `${crop.color}20` }}
                  >
                    {crop.icon}
                  </span>
                  <span className="font-medium text-slate-700 dark:text-slate-300">{crop.name}</span>
                </div>
              </td>
              <td className="px-4 py-3 text-slate-600 dark:text-slate-300">{crop.precipitationTotal}</td>
              <td className="px-4 py-3 text-slate-600 dark:text-slate-300">{crop.tempOptimalMin}</td>
              <td className="px-4 py-3 text-slate-600 dark:text-slate-300">{crop.tempOptimalMax}</td>
              <td className="px-4 py-3 text-slate-600 dark:text-slate-300">{crop.radiationTotal}</td>
              <td className="px-4 py-3 text-slate-600 dark:text-slate-300">{crop.projectedYield}</td>
              <td className="px-4 py-3 text-slate-600 dark:text-slate-300">{crop.cycleDays}</td>
              <td className="px-4 py-3">
                <button
                  onClick={() => onEdit(crop)}
                  className="px-3 py-1.5 bg-green-500 text-white rounded-lg text-sm font-medium hover:bg-green-600 transition-colors flex items-center gap-1.5"
                >
                  ✏️ Editar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)

export default CropRequirementsTable


